export default {
      id: "paper-money-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "sprite.svg#paper-money",
      toString: function () {
        return this.url;
      }
    }